
// import pic1 from '../assets/WhatsApp_Image_2023-03-23_at_11.37.16_AM-removebg-preview (1).png';
import pic1 from './kunal2.jpg';
import pic2 from './puru.jpeg';
import pic3 from './tejus.jpeg';
import pic4 from './abhishek.jpeg';
import pic5 from './shubham.jpeg';
const reviews = [
  {
    id: 1,
    name: "Kunal Ligwal",
    job: "Full-Stack Developer",
    image: pic1,
    text: "I have had the pleasure of working with this team on several projects, and I am consistently impressed with their technical expertise and ability to deliver quality solutions on time and within budget. They are a true partner and an asset to any project.",
  },
  {
    id: 2,
    name: "Purushottam Kumar",
    job: "Software Developer",
    image: pic2,
    text: "I have been working with this company for several years now, and I have always been impressed with their creativity and attention to detail. They are true professionals who take pride in their work and always go above and beyond to deliver exceptional results.",
  },
  {
    id: 3,
    name: "Tejus Sinha",
    job: "Java Developer",
    image: pic3,
    text: "I am thrilled with the results of our recent marketing campaign, and it wouldn't have been possible without the hard work and dedication of the entire team. Thank you for your exceptional work!",
  },
  {
    id: 4,
    name: "Abhishek Kumar",
    job: "Full-Stack Developer",
    image: pic4,
    text: "I have worked with many content creators over the years, but none have impressed me as much as this team. They have a knack for crafting compelling and engaging content that resonates with our audience and drives real results. I highly recommend them!",
  },
  {
    id: 5,
    name: "Shubham Raj",
    job: "Software Engineer",
    image: pic5,
    text: "I had the opportunity to work with this team on a data analysis project, and I was impressed with their attention to detail and their ability to work with complex datasets. They provided valuable insights that helped us make informed business decisions. It was a pleasure working with them.",
  },
];

export default reviews;
